import { icons } from 'src/assets/iconDef/icon.def';

export const chatbotMenuDef = [
]
